export default class extends Controller {

  connect() {
    const daySelector = document.querySelector('.day-select');
    const activeWeek = daySelector.querySelector('.active');
    const activeWeekOffset = activeWeek ? activeWeek.getBoundingClientRect() : null;

    daySelector.scrollLeft = activeWeekOffset && activeWeekOffset.x;

    AppMobile.FilterDropdown.init();
  }

  contentChange(event) {
    event.preventDefault()
    App.Helpers.ajaxRequest({
      url: event.currentTarget.href,
      successHandler: (res => App.Helpers.replaceElement(this.element, res)).bind(this)
    })
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/dashboard/multi-dashboard-calendar-controller.js